/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */
import sunsetProperty from '../../utilities/warning/sunset-property';

var checkProps = function checkProps() {};

if (process.env.NODE_ENV !== 'production') {
  checkProps = function checkProps(COMPONENT, props) {
    if (typeof props.assistiveText === 'string') {
      sunsetProperty(COMPONENT, props.assistiveText, 'assistiveText', '`assistiveText` as a string has been deprecated and is now an object to allow for multiple uses in the component. Please use `assistiveText.label` instead.');
    }
  };
}

export default checkProps;
//# sourceMappingURL=check-props.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@salesforce/design-system-react/module/components/breadcrumb/check-props.js
// module id = 209
// module chunks = 0